<template>
    <div class="search_container" :class="toFold ? '' : 'fold'">
        <div class="select_tag">
            <div class="select_tag_item">
                <span>已选条件</span>
                <div v-if="(tags.length > 0 && tags.length < 5)">
                    <el-tag v-for="(tag, index) in tags" :key="index" size="small" closable
                        @close="changeFilter(tag, index)">
                        <span class="tag_con">{{ tag.name }}</span>
                    </el-tag>
                </div>
                <div v-else-if="tags.length > 5">
                    <el-tag v-for="(tag, index) in tags.slice(0, 4)" :key="index" size="small" closable>
                        <span class="tag_con">{{ tag.name }}</span>
                    </el-tag>
                    <div class="tag_more" v-if="toFold" @click="changeFoldPanel">
                        +{{ (tags.length - 4) }}&nbsp;<i class="el-icon-arrow-down"></i>
                    </div>
                </div>
            </div>
            <el-button type="text" size="small" class="text_btn reset_btn" icon="el-icon-refresh" v-if="tags.length > 0"
                @click="reSetFilter">重置筛选</el-button>
        </div>
        <div class="filter_panel">
            <div class="filter_group" v-for="(item, index) in filterRule" :key="index">
                <div class="filter_group_title">{{ item.title }}</div>
                <div class="filter_group_items" v-if="(item.title == '省份' && index == 0)">
                    <el-radio-group ref="provence_group" v-model="item.check" text-color="#4FA1A4"
                        @input="(val) => changeTags(val, item)">
                        <el-radio class="icon_hide" v-for="prov in item.options" :key="prov.areaCode"
                            :label="prov.areaCode + '_' + prov.areaName">{{ prov.areaName }}</el-radio>
                    </el-radio-group>
                </div>
                <div class="filter_group_items group_bg" v-else-if="(item.title == '城市' && index == 1)">
                    <el-checkbox-group ref="city_group" v-model="item.check" @change="(val) => changeTags(val, item)">
                        <el-checkbox v-for="city in item.options" :key="city.areaCode"
                            :label="city.areaCode + '_' + city.areaName">{{ city.areaName }}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div class="filter_group_items" v-else-if="item.multiple">
                    <el-checkbox-group v-model="item.check" @change="(val) => changeTags(val, item)">
                        <el-checkbox v-for="(box, b) in item.options" :key="b + '_' + box.value"
                            :label="box.value + '_' + box.label">{{ box.label }}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div class="filter_group_items" v-else-if="item.type == 'autocomplete'">
                    <el-autocomplete v-model="item.check" size="mini" :fetch-suggestions="querySearch" placeholder="请输入渠道名称"
                        clearable @select="handleSelect" @clear="handleSelect('clear')">
                        <template slot-scope="{ item }">
                            <div class="name">{{ item.name }}</div>
                        </template>
                    </el-autocomplete>
                </div>
                <div class="filter_group_items" v-else>
                    <el-radio-group v-model="item.check" @input="(val) => changeTags(val, item)">
                        <el-radio class="icon_hide" v-for="(opt, o) in item.options" :key="o + '_' + opt.value"
                            :label="opt.value + '_' + opt.label">{{ opt.label }}</el-radio>
                    </el-radio-group>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { salesmanRule, terminalRule, channelRule } from '@/uilt/linkage'
import { getAreaInfo, setDatas, getChannelList } from '@/api/portrait.js'
export default {
    props: {
        isFold: {
            type: Boolean,
            default: true
        },
        searchType: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            parentCode: '',
            tagPanelH: null,
            tags: [],
            filterRule: [],
            // provinceData: [],
            // cityData: [],
            restaurants: []
        };
    },
    created() {
        if (this.$route.path.indexOf('salesmanDetail') > -1) {
            return
        }

        if (sessionStorage.getItem('childDatas')) {
            let datas = setDatas('search_filter')
            Object.assign(this.$data, datas)
        } else {
            this.getProvence(true)
            this.getMemberChannelData()
        }
    },
    computed: {
        toFold() {
            return this.isFold
        }
    },
    watch: {

    },
    methods: {
        // 获取地区数据
        getProvence(init) {
            let param = init ? {} : { parentCode: this.parentCode }
            getAreaInfo(param).then((res) => {
                let data = res.data
                this.parentCode = data[0].areaCode
                if (init) {
                    const list = [
                        {
                            title: '省份',
                            field: 'provinceCode',
                            check: '',
                            options: data
                        }, {
                            title: '城市',
                            field: 'cityCode',
                            multiple: true,
                            check: [],
                            options: []
                        }
                    ]
                    if (this.$route.query.toRoute == 'list') {
                        let distArr = this.$route.query.data.split(' ').map(item => JSON.parse(item))
                        list[0].check = distArr[0] ? distArr[0].adcode + "_" + distArr[0].name : ""
                        list[1].check = distArr[1] ? [distArr[1].adcode + "_" + distArr[1].name] : []
                        if (distArr[0] && distArr[1]) {
                            this.tags = [
                                { field: 'provinceCode', name: distArr[0].name + '；' + distArr[1].name },
                            ]
                        } else if (distArr[0] && !distArr[1]) {
                            this.tags = [
                                { field: 'provinceCode', name: distArr[0].name }
                            ]
                        }
                        if (distArr.length) {
                            this.parentCode = distArr[0].adcode
                            this.$emit('setFilter', { provinceCode: distArr[0].adcode, cityCode: [distArr[1].adcode] }, true)
                        }
                    }

                    if (this.searchType == '1') {
                        this.filterRule = [...list, ...salesmanRule]
                    } else if (this.searchType == '2') {
                        terminalRule[1].options = terminalRule[0].options[0].child
                        this.filterRule = [...list, ...terminalRule]
                    }
                    this.getProvence(false);
                } else {
                    this.filterRule[1].options = data
                    // let filterItem = JSON.parse(JSON.stringify(this.filterRule[1]))
                    // filterItem.options = data
                    // this.$set(this.filterRule, 1, filterItem)
                }
            })
        },
        // 改变搜索类型
        changeType() {
            this.filterRule.splice(2, this.filterRule.length - 2)
            if (this.searchType == '1') {
                this.filterRule = [...this.filterRule, ...salesmanRule]
            } else if (this.searchType == '2') {
                terminalRule[1].options = terminalRule[0].options[0].child
                this.filterRule = [...this.filterRule, ...terminalRule]
            } else if (this.searchType == '3') {
                this.filterRule = [...this.filterRule, ...channelRule]
            }
            this.reSetFilter()
        },
        // 选中条件 改变标签
        changeTags(val, row) {
            let value = [],
                param = {};
            if (row.multiple) {
                value = val.map(v => {
                    v = v.split('_')[0]
                    return v
                })
            } else {
                value = val.split('_')
            }
            param[row.field] = row.multiple ? value : value[0]
            this.$emit('setFilter', param, false)
            if (row.field == 'provinceCode') {
                this.parentCode = value[0]
                this.filterRule[1].check = []
                this.getProvence(false)
            } else if (row.field == 'terminalType') {
                this.filterRule[3].check = ''
                if (this.searchType == '2') {
                    row.options.map(item => {
                        if ((item.value + '_' + item.label) == val) {
                            this.filterRule[3].options = item.child
                        }
                    })
                }
            }
            let isExit = false, index = null
            this.tags = this.tags.map((t, i) => {
                if (row.field == t.field || (row.field == 'cityCode' && t.field == 'provinceCode')) {
                    if (val.length == 0) {
                        index = i
                        if (row.field == 'cityCode' && t.field == 'provinceCode')
                            t.name = t.name.split('；')[0]
                    }
                    isExit = true
                }
                return t
            })
            if (val.length == 0) {
                if (row.field != 'cityCode') {
                    this.tags.splice(index, 1)
                }
                return
            }
            if (isExit) {
                this.tags = this.tags.map(item => {
                    if (row.field == 'cityCode' && item.field == 'provinceCode') {
                        item.name = item.name.split('；')[0] + '；' + val.map(v => {
                            v = v.split('_')[1]
                            return v
                        }).join('、')
                    } else {
                        if (row.field == item.field) {
                            if (row.multiple) {
                                item.name = val.map(v => {
                                    v = v.split('_')[1]
                                    return v
                                }).join('、')
                            } else {
                                item.name = value[1]
                            }
                        }
                    }

                    return item;
                })

            } else {
                let tag = {}
                if (row.field == 'cityCode') {
                    tag.field = 'provinceCode'
                    tag.name = row.options[0].parentName
                    tag.name += '；' + val.map(v => {
                        v = v.split('_')[1]
                        return v
                    }).join('、')
                    this.filterRule[0].check = row.options[0].parentCode + '_' + row.options[0].parentName
                    param['provinceCode'] = row.options[0].parentCode
                    this.$emit('setFilter', param, false)
                } else {
                    tag = {
                        field: row.field,
                        name: row.multiple ? val.map(v => {
                            v = v.split('_')[1]
                            return v
                        }).join('、') : value[1]
                    }
                }
                this.tags.push(tag)
            }
            // console.log(this.tags)
        },
        // 删除标签 改变条件
        changeFilter(row, index) {
            this.tags.splice(index, 1);
            let param = {}
            this.filterRule = this.filterRule.map((item, i) => {
                if (row.field == 'provinceCode') {
                    if (item.field == 'cityCode') {
                        item.check = [];
                        param[item.field] = item.check
                    } else if (item.field == 'provinceCode') {
                        item.check = '';
                        param[item.field] = item.check
                    }
                } else {
                    if (item.field == row.field) {
                        item.check = item.multiple ? [] : ''
                        param[item.field] = item.check
                    }
                }
                return item
            })

            this.tags.length == 0 ? this.$emit('setFilter', null, true) : this.$emit('setFilter', param, true)
        },
        // 展开收缩
        changeFoldPanel() {
            this.$emit('changeFold', this.toFold)
        },
        // 重置筛选
        reSetFilter() {
            this.filterRule = this.filterRule.map(item => {
                item.check = item.multiple ? [] : ''
                return item
            })
            this.tags = []
            this.$emit('setFilter', null, true)
        },
        // 获取会员渠道数据
        getMemberChannelData() {
            let param = {
                keyword: '',
                pageSize: -1,
                pageIndex: 1
            }
            getChannelList(param).then(res => {
                this.restaurants = (res.data.records && res.data.records.length) ? res.data.records : []
            })
        },
        // 输入建议匹配
        async querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        // 结果列表选中
        handleSelect(item) {
            this.filterRule.at(-1).check = item == 'clear' ? '' : item.name
            let param = {
                channelDamId: item == 'clear' ? '' : item.damId
            }
            this.$emit('setFilter', param, false)
        }
    },
};
</script>
<style lang="less" scoped>
.search_container {
    height: 186px;
    overflow: hidden;
    transition: all .8s;

    &.fold {
        height: auto;
    }
}

.select_tag {
    height: 48px;
    padding: 0 15px;
    border-bottom: 1px solid #d9d9d9;
    display: flex;
    justify-content: space-between;

    &_item {
        width: calc(100% - 90px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: left;

        >span {
            display: block;
            width: 86px;
            line-height: 48px;
        }

        >div {
            width: calc(100% - 85px);
            display: flex;
            align-items: center;
            overflow: hidden;

            /deep/.el-tag {
                color: #4FA1A4;
                background: #fff;
                margin-right: 5px;
                border: 1px solid #4FA1A4;
                border-radius: 0;
                font-size: 14px;

                .tag_con {
                    display: inline-block;
                    max-width: 172px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    vertical-align: middle;
                }
            }

            .tag_more {
                height: 22px;
                line-height: 22px;
                border: 1px solid #d9d9d9;
                padding: 0 5px;
                background: #d9d9d9;
                border-radius: 2px;
                font-size: 12px;
                color: #747474;
                margin-left: 10px;
                letter-spacing: 1px;
                cursor: pointer;

                &:hover {
                    background: #4FA1A4;
                    border-color: #4FA1A4;
                    color: #fff;
                }
            }
        }
    }
}

button.el-button.text_btn {
    border: none;
    color: #474747;
    font-size: 14px;

    &.reset_btn {
        color: #4FA1A4;
    }
}

.filter_panel {
    padding: 5px 15px 0;

    .filter_group {
        line-height: 36px;
        display: flex;
        // justify-content: space-between;

        &_title {
            width: 94px;
            color: #999;
            text-align: left;
        }

        &_items {
            width: calc(100% - 203px);
            padding: 0 10px;
            text-align: left;

            .el-button.text_btn {
                color: #747474;
                margin: 0;
                margin-right: 10px;

                &.active {
                    color: #4FA1A4;
                }
            }

            .el-autocomplete {
                width: 300px;
            }

            &.group_bg {
                /deep/.el-checkbox-group {
                    background: #F4F6F9;
                }
            }

            /deep/.el-checkbox-group {
                text-align: left;
                // background: #F4F6F9;
                padding: 0 10px;
                margin: 0 -10px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                .el-checkbox__inner {
                    border-color: #c6c6c6;
                }

                .el-checkbox__input.is-checked .el-checkbox__inner {
                    background: #4FA1A4;
                    border-color: #4FA1A4;
                }


                .el-checkbox__label {
                    color: #747474;

                    &:hover {
                        color: #4FA1A4;
                    }
                }
            }

            /deep/.el-radio-group {
                margin: 4px 0;

                .el-radio {
                    &.icon_hide {
                        line-height: 28px;

                        .el-radio__input {
                            display: none;

                            &.is-checked+.el-radio__label {
                                color: #4FA1A4;
                            }
                        }
                    }

                    .el-radio__label {
                        color: #747474;
                        padding-left: 0;

                        &:hover {
                            color: #4FA1A4;
                        }
                    }
                }


            }
        }
    }
}
</style>
